import React, { useState, useEffect } from 'react';
import { signOut, getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';

import Button from 'components/Buttons/Button';
import oIconLibrary from 'utils/iconLibrary';
import { fnGetIdpIconFromUsername } from './helpers';

const IdentityProviderAccountManagement = () => {
  const [sSignedInAccount, fnSetSignedInAccount] = useState('');
  const [sIdp, fnSetIdp] = useState('');

  useEffect(() => {
    const fnGetSignedInAccount = async () => {
      try {
        const { username } = await getCurrentUser();
        const oUserAttributes = await fetchUserAttributes();
        fnSetSignedInAccount(oUserAttributes.email);
        fnSetIdp(fnGetIdpIconFromUsername(username));
      } catch (oError) {
        console.error('Error fetching identity provider account:', oError);
      }
    };
    fnGetSignedInAccount();
  }, []);

  const fnSignOut = () => signOut({ global: true });
  return sSignedInAccount ? (
    <div className='authLayout__identityProviderAccountManagement'>
      <p className='authLayout__identityProviderAccount t-paragraph--small'>
        Logged in with <img src={oIconLibrary.wfu[sIdp]} alt={`${sIdp} logo`} />{' '}
        as <strong>{sSignedInAccount}</strong>
      </p>
      <Button
        sFlavor='underline'
        fnHandleClick={fnSignOut}
        className='authLayout__identityProviderAccountSignOut'
      >
        Sign Out
      </Button>
    </div>
  ) : null;
};

export default IdentityProviderAccountManagement;
